import React from 'react';

/**
 * Basic flex wrapper for children elements to neatly place them in a practical and reusable manner
 */
import cx from 'classnames';

interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  row?: boolean;
  children: React.ReactNode;
  width?: number;
  center?: boolean;
  verticalCenter?: boolean;
  horizontalCenter?: boolean;
  fillHeight?: boolean;
  devOutline?: boolean;
  fillWidth?: boolean;
  margin?: string;
  className?: string;
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  function Container(
    {
      children,
      row,
      width,
      verticalCenter,
      horizontalCenter,
      fillHeight,
      devOutline,
      fillWidth,
      margin,
      className,
      ...rest
    }: ContainerProps,
    ref
  ): React.ReactElement {
    const containerCx = cx(
      'flex',
      row ? 'flex-row' : 'flex-col',
      verticalCenter && (row ? 'items-center' : 'justify-center'),
      horizontalCenter && (row ? 'justify-center' : 'items-center'),
      fillHeight && 'h-full',
      fillWidth && 'w-full items-stretch',
      className && className
    );
    const getMargin = () => {
      if (margin) {
        return { margin: margin };
      }
      return {};
    };
    const getInlineStyle = {
      flex: width ? `${width} 0px` : 0,
      outline: devOutline ? '1px solid #FF5A5F' : 0,
      ...getMargin(),
    };
    return (
      <div className={containerCx} style={getInlineStyle} {...rest} ref={ref}>
        {children}
      </div>
    );
  }
);
